import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faPaperPlane as fasPaperPlane } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, List } from "bm-ui-kit";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";
import { SZECHENYI_LOAN_NAMES } from "../domain";
import type { SzechenyiLoanType } from "../types";

interface StepFields {}

interface Props extends AbstractStepProps {
	availableLoans: SzechenyiLoanType[];
}

export class ResultSuccess extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const { availableLoans } = this.props;

		return (
			<>
				<Card.Header className="bg-success">
					<div className="h5 mb-0 text-white text-center">
						Az adatok alapján az új <strong>Széchenyi Kártya Program MAX+</strong> feltételeinek megfelelsz!
					</div>
				</Card.Header>
				<Card.Body className="d-flex flex-column font-weight-light">
					<div>A választott hitelcélnak ajánlott kedvezményes termékkonstrukció:</div>
					<div className="mt-3">
						<List itemStyle="tick" variant="gold" className="font-weight-bold">
							{availableLoans.map((loan) => (
								<List.Item key={loan}>{SZECHENYI_LOAN_NAMES[loan]}</List.Item>
							))}
						</List>
					</div>
				</Card.Body>
				{this.renderDetails()}
			</>
		);
	}

	protected renderDetails(): ReactNode {
		return (
			<Card.Body className="szechenyi-details-box px-3 d-flex flex-column justify-content-center rounded-bottom">
				<div className="mb-3 text-center">
					<strong>Az elérhető hitel részleteit e-mailben küldjük meg a számodra</strong>
				</div>
				<List itemStyle="tick" variant="gold">
					<List.Item>
						<strong>Milyen összegű</strong> hitelt kaphat a céged?
					</List.Item>
					<List.Item>
						Milyen <strong>futamidő</strong> mellett?
					</List.Item>
					<List.Item>Mi a különbség a bankok között?</List.Item>
					<List.Item>Hogyan kerüld el a buktatókat?</List.Item>
				</List>
				<div className="text-center pt-2">
					A Bankmonitor szakértője teljeskörű támogatást nyújt hiteligényedhez!
				</div>
				<Button type="submit" variant="gold" className="mt-3" icon={<FontAwesomeIcon icon={fasPaperPlane} />}>
					Kérem a részletes eredményeim
				</Button>
			</Card.Body>
		);
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success", "success-step"]).join(" ");
	}

	protected getComponentName(): string {
		return "ResultSuccess";
	}
}
